<script lang="ts" setup>
interface IconProps {
  pack?: string;
  icon: string;
  size?: string;
  type?: string;
  color?: string;
}

const { pack = "fas", icon, size, type, color } = defineProps<IconProps>();
</script>

<template>
  <b-icon
    class="container-icon"
    :icon="icon"
    :pack="pack"
    :size="size"
    :type="type"
    :color="color"
    :style="color ? { '--ui-icon-color': color } : undefined"
  />
</template>

<style lang="scss" scoped>
.container-icon {
  margin: 0;
}
:deep(svg) {
  color: var(--ui-icon-color);
  fill: currentColor;
}
</style>
